import React from "react";
import { Svg, Path, SvgProps } from "react-native-svg";

const CorrectIcon = (props: SvgProps) => {
  return (
    <Svg viewBox="0 0 14 10" {...props}>
      <Path
        d="M4.62098 6.78741L11.592 1.15445L11.592 1.15447C11.9904 0.835212 12.5712 0.895807 12.8933 1.29437C13.2154 1.69056 13.1519 2.27402 12.7559 2.59343L4.62098 6.78741ZM4.62098 6.78741L2.62894 3.96917L2.6289 3.96912C2.33334 3.55223 1.75779 3.45173 1.34054 3.74742L1.34053 3.74743C0.923443 4.04313 0.825807 4.61862 1.11871 5.03562L1.1188 5.03574L3.68099 8.65927L3.68102 8.65931C3.82887 8.86801 4.05596 9.00505 4.30892 9.04202L4.30991 9.04214C4.35193 9.04742 4.39403 9.05 4.43599 9.05C4.6472 9.05 4.85062 8.97864 5.01686 8.8441L12.7559 2.59345L4.62098 6.78741Z"
        strokeWidth="0.1"
      />
    </Svg>
  );
};

export default CorrectIcon;
